import React, { FC } from 'react';
import {
  AspectRatioRounded,
  ClearRounded,
  DeleteForeverRounded,
  InputRounded,
  TimelineRounded,
} from '@mui/icons-material';

import { DrainFunnelObjectType } from '../../constructor/types';
import { ItemMenuComponentType, MenuComponent } from '../MenuComponent';
import { Edit } from '../../constructor/work/Edit';

interface Props {
  positionX: number;
  positionY: number;
  parentDrainFunnel: DrainFunnelObjectType | null;
  uuidChild: string;
  closeMenu(): void;
}
type ActionsType = 'delete' | 'add point' | 'scale' | 'input';

export const MenuDrainFunnel: FC<Props> = ({
  positionX,
  positionY,
  closeMenu,
  uuidChild,
  parentDrainFunnel,
}) => {
  const handleDeleteDrainFunnel = () => {
    if (parentDrainFunnel) {
      const quantityDrainObjects = parentDrainFunnel.removeSelectedChildren(uuidChild);
      if (quantityDrainObjects === 0) {
        Edit.removeDrainFunnel();
      }
    }
  };

  const itemsMenu: Array<ItemMenuComponentType<ActionsType>> = [
    {
      title: 'delete',
      icon: <DeleteForeverRounded />,
      onClickMenuItem: handleDeleteDrainFunnel,
    },
    { title: 'scale', icon: <AspectRatioRounded /> },
    { title: 'add point', icon: <TimelineRounded /> },
    { title: 'input', icon: <InputRounded /> },
    { title: 'close', icon: <ClearRounded /> },
  ];

  return (
    <MenuComponent
      closeMenu={closeMenu}
      positionX={positionX}
      positionY={positionY}
      itemsMenu={itemsMenu}
    />
  );
};
